import { Action } from '@ngrx/store';
import { FireStoreDocument } from '@digitaix/types';

export enum UploadActionTypes {
  UploadFile = '[Upload] Upload File',
  Failed = '[Upload] Failed',
  Completed = '[Upload] Completed',
  Progress = '[Upload] Progress',
}

export class UploadFile implements Action {
  public readonly type = UploadActionTypes.UploadFile;

  constructor(
    public payload: {
      file: File;
      path: string;
      document?: FireStoreDocument;
      md5?: boolean;
    },
    public tracer?: string,
  ) {}
}

export class UploadFailed implements Action {
  public readonly type = UploadActionTypes.Failed;

  constructor(public error: any, public tracer: string) {}
}

export class UploadCompleted implements Action {
  public readonly type = UploadActionTypes.Completed;

  constructor(public downloadURL: string, public tracer: string) {}
}

export class UploadProgress implements Action {
  public readonly type = UploadActionTypes.Progress;

  constructor(public progress: string, public tracer: string) {}
}

export type UploadActions =
  | UploadFile
  | UploadFailed
  | UploadCompleted
  | UploadProgress;
